








































import { defineComponent } from '@vue/composition-api';

const RevenueInformation = defineComponent({
  setup() {
    const incomeCustomer = [
      { name: 'ประเภทที่ 1', data: 457, color: 'green' },
      { name: 'ประเภทที่ 2', data: 87, color: 'blue' },
      { name: 'ประเภทที่ 3', data: 130, color: 'yellow' },
      { name: 'ประเภทที่ 4', data: 30, color: 'red' },
      { name: 'ประเภทที่ 5', data: 175, color: 'gray' },
    ];
  },
});

export default RevenueInformation;
